import zh_CN from './zh-CN'
import zh_TW from './zh-TW'
import en from './en'
import ja from './ja'
import ko from './ko'
import ru from './ru'
import de from './de'
import fr from './fr'
import es from './es'
import pt from './pt'
import it from './it'
import ar from './ar'
import tr from './tr'
import vi from './vi'
import th from './th'
import id from './id'
import ms from './ms'
import kk from './kk'
import my from './my'
import lo from './lo'

export default {
  'zh-CN': zh_CN,
  'zh-TW': zh_TW,
  'en': en,
  'ja': ja,
  'ko': ko,
  'ru': ru,
  'de': de,
  'fr': fr,
  'es': es,
  'pt': pt,
  'it': it,
  'ar': ar,
  'tr': tr,
  'vi': vi,
  'th': th,
  'id': id,
  'ms': ms,
  'kk': kk,
  'my': my,
  'lo': lo,
}
